// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	const burgerMenuBtn = document.getElementById('js-menu-trigger');
	const burgerMenuClose = document.getElementById('js-close-menu');
	const burgerMenu = document.getElementById('burger-menu');

	if(burgerMenuBtn) {
		burgerMenuBtn.addEventListener('click', (e) =>{
			e.preventDefault();
			burgerMenu.classList.add('open');
			document.body.classList.add('no-scroll');
		});


		burgerMenuClose.addEventListener('click', () =>{
			burgerMenu.classList.remove('open');
			document.body.classList.remove('no-scroll');
		});
	}


	let social_media_whatsapp = document.querySelector( ".social-media .vimeo" )
	if( social_media_whatsapp ){
		social_media_whatsapp.dataset.title = "whatsapp"
		social_media_whatsapp.setAttribute( "aria-label", "whatsapp icon" )
	}


    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}